import React from 'react';

export function CheckMark () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#58C3BB"
        fillRule="evenodd"
        d="M19.082 3.699a1.297 1.297 0 00-1.834 0l-9.844 9.844L2.75 8.889a1.296 1.296 0 00-1.833 1.834l5.664 5.665a1.164 1.164 0 001.645 0L19.082 5.533a1.297 1.297 0 000-1.834z"
        clipRule="evenodd"
      />
    </svg>
  );
}
